import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from 'shared/ui/error-boundary';
import CardReplacementRequestsPage from 'pages/card-replacement-requests.page';
const CardReplacementRequestRoutes = () => (_jsx(Routes, { children: _jsx(Route, { path: "*", element: _jsx(ErrorBoundary, { children: _jsx(CardReplacementRequestsPage, {}) }) }) }));
export const CMS_NAV_ITEM = {
    id: 'card-replacement-requests',
    pathSegment: 'card-replacement-requests',
    labelKey: 'form.cardReplacementRequests',
    icon: 'pi pi-sync',
    authorityKeys: ['ADMIN'],
    RoutesComponent: CardReplacementRequestRoutes,
};
export default CardReplacementRequestRoutes;
